// global: addressedTo values: "CLIENTE" || "PACIENTE"
// global: type values: "FACTURA" || "NC" || "ND"
// local: iva: values true || false;

//CAMBIOS_FACTURA
import moment from 'moment';

const BuildXml = (data, type, addressedTo) => {
    console.log("holaaaa",data);
    var iva = false;
    var doc = document.implementation.createDocument("", "", null);
    var facturaXML = null;


    if (type === "FACTURA") {
        facturaXML = doc.createElement("FACTURA");
        facturaXML.setAttribute("xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
        facturaXML.setAttribute("xmlns:xsd", "http://www.w3.org/2001/XMLSchema");
        console.log(facturaXML);
    } else if (type === "NC" || type === "ND") {
        facturaXML = doc.createElement("NOTA");
    }

    facturaXML.appendChild(ENC(doc, type, addressedTo, data));
    facturaXML.appendChild(EMI(doc, iva, data));
    facturaXML.appendChild(ADQ(doc, iva, addressedTo, data));
    facturaXML.appendChild(TOT(doc, type, iva, data));
    //facturaXML.appendChild(NOT(doc, data));
    if (iva) {
        facturaXML.appendChild(TIM(doc, iva, data));
    }
    /*if(addressedTo === "Paciente"){
        if(data.reciboCaja.tipo_pago === "CUOTA MODERADORA" || data.reciboCaja.tipo_pago === "COPAGO"){
            facturaXML.appendChild(ANT(doc, addressedTo, data));
        } 
    }*/
    facturaXML.appendChild(DRF(doc, data));

    if (type === "ND") {
        facturaXML.appendChild(REF(doc, type, data));
        facturaXML.appendChild(CND(doc, data.notad.observaciones));
    } else if (type === "NC") {
        facturaXML.appendChild(REF(doc, type, data));
        facturaXML.appendChild(CND(doc, data.notac.observaciones));
    }

    if (type === "FACTURA") {
        facturaXML.appendChild(MEP(doc, type, addressedTo, data));
    }
    var descuento = 0;
    //var items = [{ precio: 30000 }, { precio: 5000 }];

    ITEM(doc, facturaXML, type, iva, addressedTo, data, descuento);
    doc.appendChild(facturaXML);
    return doc;
}


const ENC = (doc, type, addressedTo, data) => {
    let typeBill = null;
    let typeOperation = null;
    let code = null;

    switch (type) {
        case "FACTURA":
            typeBill = "INVOIC";
            typeOperation = 10;
            code = '01';
            break;
        case "ND":
            typeBill = type;
            typeOperation = 30;
            code = '92';
            break;
        case "NC":
            typeBill = type;
            typeOperation = 20;
            code = '91';
            break;
    }

    var cantidad = 0;
    if (addressedTo === "Tercero") {
        cantidad = data.factTercero.servicios.recibos_caja.length;
    } else if (addressedTo === "Paciente") {
        cantidad = data.reciboCaja.servicios.servicios.length;
    }

    var ENC = doc.createElement("ENC");

    var ENC_1 = doc.createElement("ENC_1");
    ENC_1.innerHTML = typeBill;
    var ENC_2 = doc.createElement("ENC_2");
    ENC_2.innerHTML = data.clinica.nit.split("-")[0];

    var ENC_3 = doc.createElement("ENC_3");
    if (addressedTo === "Tercero") {
        ENC_3.innerHTML = data.tercero.nit.split("-")[0]; // NIT tercero
    } else if (addressedTo === "Paciente") {
        ENC_3.innerHTML = data.paciente.num_documento; //documento paciente
    }

    var ENC_4 = doc.createElement("ENC_4");
    ENC_4.innerHTML = "UBL 2.1";
    var ENC_5 = doc.createElement("ENC_5");
    ENC_5.innerHTML = "DIAN 2.1";

    var ENC_6 = doc.createElement("ENC_6");
    if (addressedTo === "Paciente")
        ENC_6.innerHTML = data.factura.factTercero.num_fac_ter.split("-")[0] + data.factura.factTercero.num_fac_ter.split("-")[1];
    else if (addressedTo === "Tercero")
        ENC_6.innerHTML = data.factTercero.num_fac_ter.split("-")[0] + data.factTercero.num_fac_ter.split("-")[1];
    var ENC_7 = doc.createElement("ENC_7");
    ENC_7.innerHTML = moment(new Date()).format("YYYY-MM-DD"); //fecha de nota
    var ENC_8 = doc.createElement("ENC_8");// hora de nota 
    ENC_8.innerHTML = moment(new Date()).format("HH:mm:ss") + "-05:00";

    var ENC_9 = doc.createElement("ENC_9");
    ENC_9.innerHTML = code;

    var ENC_10 = doc.createElement("ENC_10");
    ENC_10.innerHTML = "COP";

    var ENC_11 = doc.createElement("ENC_11");
    var ENC_12 = doc.createElement("ENC_12");
    if (addressedTo === "Paciente") {

        ENC_11.innerHTML = moment(new Date()).format();
        ENC_12.innerHTML = moment(new Date()).format();

    } else if (addressedTo === "Tercero") {

        ENC_11.innerHTML = data.fecha_inicio;
        ENC_12.innerHTML = data.fecha_final;
    }

    var ENC_15 = doc.createElement("ENC_15");
    ENC_15.innerHTML = cantidad;

    var ENC_16 = doc.createElement("ENC_16");
    ENC_16.innerHTML = moment(new Date()).format("YYYY-MM-DD"); //fecha vencimiento

    var ENC_17 = doc.createElement("ENC_17");
    ENC_17.innerHTML = 'sftp://elpago.com.xz';

    var ENC_18 = doc.createElement("ENC_17");
    ENC_18.innerHTML = 'www.warescolombia.net';

    var ENC_20 = doc.createElement("ENC_20");
    ENC_20.innerHTML = 2;

    var ENC_21 = doc.createElement("ENC_21"); // tipo de operacion si FE (10) si NC (20)  si ND (30)
    ENC_21.innerHTML = typeOperation;

    ENC.appendChild(ENC_1);
    ENC.appendChild(ENC_2);
    ENC.appendChild(ENC_3);
    ENC.appendChild(ENC_4);
    ENC.appendChild(ENC_5);
    ENC.appendChild(ENC_6);
    ENC.appendChild(ENC_7);
    ENC.appendChild(ENC_8);
    ENC.appendChild(ENC_9);
    ENC.appendChild(ENC_10);
    ENC.appendChild(ENC_11);
    ENC.appendChild(ENC_12);
    ENC.appendChild(ENC_15);
    ENC.appendChild(ENC_16);
    ENC.appendChild(ENC_17);
    ENC.appendChild(ENC_18);
    ENC.appendChild(ENC_20);
    ENC.appendChild(ENC_21);
    return ENC;
}

const EMI = (doc, iva, data) => {

    var EMI = doc.createElement("EMI");
    var EMI_1 = doc.createElement("EMI_1");
    EMI_1.innerHTML = 1; //codigo 1 persona Juridica

    var EMI_2 = doc.createElement("EMI_2");
    EMI_2.innerHTML = data.clinica.nit.split("-")[0]; //NIT de la empresa

    var EMI_3 = doc.createElement("EMI_3");
    EMI_3.innerHTML = 31;

    var EMI_4 = doc.createElement("EMI_4");
    if (iva) {
        EMI_4.innerHTML = 0;
    } else {
        EMI_4.innerHTML = 2;
    }
    var EMI_5 = doc.createElement("EMI_5");

    var EMI_6 = doc.createElement("EMI_6"); //nombre de la empresa
    EMI_6.innerHTML = data.clinica.nombre;
    var EMI_7 = doc.createElement("EMI_7"); //nombre de la empresa
    EMI_7.innerHTML = data.clinica.nombre;
    var EMI_10 = doc.createElement("EMI_10"); //dirección de la empresa (inf)
    EMI_10.innerHTML = data.clinica.direccion.direccion;
    var EMI_11 = doc.createElement("EMI_11"); //codigo del departamento (inf)
    EMI_11.innerHTML = "76";//data.clinica.direccion.id_dpto;
    var EMI_13 = doc.createElement("EMI_13"); // nombre de la Ciudad Mayuscula sostenida
    EMI_13.innerHTML = "CALI";//data.clinica.direccion.ciudad;
    var EMI_14 = doc.createElement("EMI_14"); // Codigo Postal
    EMI_14.innerHTML = "760036";//data.clinica.codigo_postal;
    var EMI_15 = doc.createElement("EMI_15"); //codigo del país 
    EMI_15.innerHTML = 'CO';
    var EMI_19 = doc.createElement("EMI_19"); //nombre del departamento
    EMI_19.innerHTML = "Valle del Cauca";//data.clinica.direccion.departamento; 
    var EMI_21 = doc.createElement("EMI_21"); //nombre del país
    EMI_21.innerHTML = "Colombia";
    var EMI_22 = doc.createElement("EMI_22"); //codigo de verificación NIT
    EMI_22.innerHTML = CalcularDigitoVerificacion(data.clinica.nit.split("-")[0]);
    var EMI_23 = doc.createElement("EMI_23"); //codigo de la ciudad
    EMI_23.innerHTML = "76001";//data.clinica.direccion.id_ciudad;
    var EMI_24 = doc.createElement("EMI_24"); //nombre de la empresa (inf)
    EMI_24.innerHTML = data.clinica.nombre;
    var EMI_25 = doc.createElement("EMI_25"); //codigo de actividad economica
    EMI_25.innerHTML = "8699";//data.clinica.cod_act_econ;
    var TAC = doc.createElement("TAC");
    var TAC_1 = doc.createElement("TAC_1");
    if (iva) {
        TAC_1.innerHTML = 'O-47';
    } else {
        TAC_1.innerHTML = 'R-99-PN';
    }
    TAC.appendChild(TAC_1);

    var DFE = doc.createElement("DFE");// codigo de municipio
    var DFE_1 = doc.createElement("DFE_1");
    DFE_1.innerHTML = "76001";//data.clinica.direccion.id_ciudad;
    var DFE_2 = doc.createElement("DFE_2");//codigo de departamento
    DFE_2.innerHTML = "76";//data.clinica.direccion.id_dpto;
    var DFE_3 = doc.createElement("DFE_3");//codigo de indentificadodr de pais
    DFE_3.innerHTML = "CO"
    var DFE_4 = doc.createElement("DFE_4");//codigo postal
    DFE_4.innerHTML = data.clinica.codigo_postal;
    var DFE_5 = doc.createElement("DFE_5"); //nombre del pais
    DFE_5.innerHTML = "COLOMBIA";
    var DFE_6 = doc.createElement("DFE_6"); //nombre del departamento
    DFE_6.innerHTML = "VALLE DEL CAUCA";
    var DFE_7 = doc.createElement("DFE_7"); //nombre de la ciudad
    DFE_7.innerHTML = "CALI";
    var DFE_8 = doc.createElement("DFE_8"); //dirección de la empresa
    DFE_8.innerHTML = data.clinica.direccion.direccion;;

    DFE.appendChild(DFE_1);
    DFE.appendChild(DFE_2);
    DFE.appendChild(DFE_3);
    DFE.appendChild(DFE_4);
    DFE.appendChild(DFE_5);
    DFE.appendChild(DFE_6);
    DFE.appendChild(DFE_7);
    DFE.appendChild(DFE_8);

    var ICC = doc.createElement("ICC");
    var ICC_1 = doc.createElement("ICC_1");//numero de matricula mercantil de la empresa 
    ICC_1.innerHTML = '900412421-0';
    var ICC_9 = doc.createElement("ICC_9");
    ICC_9.innerHTML = data.factura.prefijo; //prefijo de facturacion
    ICC.appendChild(ICC_1);
    ICC.appendChild(ICC_9);

    var CDE = doc.createElement("CDE");
    var CDE_1 = doc.createElement("CDE_1"); //contacto de ventas 
    CDE_1.innerHTML = 4;
    var CDE_2 = doc.createElement("CDE_2");//nombre y cargo de la persona de contacto
    CDE_2.innerHTML = data.clinica.nombre;
    var CDE_3 = doc.createElement("CDE_3");//telefono de la persona que esta a cargo
    CDE_3.innerHTML = `${data.clinica.telefono1} - ${data.clinica.telefono2}`;
    var CDE_4 = doc.createElement("CDE_4");//correo electronico de la persona que esta acargo
    CDE_4.innerHTML = data.clinica.email; //email de la empresa
    CDE.appendChild(CDE_1);
    CDE.appendChild(CDE_2);
    CDE.appendChild(CDE_3);
    CDE.appendChild(CDE_4);

    var GTE = doc.createElement("GTE");
    var GTE_1 = doc.createElement("GTE_1");
    var GTE_2 = doc.createElement("GTE_2");
    if (iva) {
        GTE_1.innerHTML = '01';
        GTE_2.innerHTML = 'IVA';
    } else {
        GTE_1.innerHTML = 'ZZ';
        GTE_2.innerHTML = 'No aplica';
    }

    GTE.appendChild(GTE_1);
    GTE.appendChild(GTE_2);
    EMI.appendChild(EMI_1);
    EMI.appendChild(EMI_2);
    EMI.appendChild(EMI_3);
    EMI.appendChild(EMI_4);
    EMI.appendChild(EMI_5);
    EMI.appendChild(EMI_6);
    EMI.appendChild(EMI_7);
    EMI.appendChild(EMI_10);
    EMI.appendChild(EMI_11);
    EMI.appendChild(EMI_13);
    EMI.appendChild(EMI_14);
    EMI.appendChild(EMI_15);
    EMI.appendChild(EMI_19);
    EMI.appendChild(EMI_21);
    EMI.appendChild(EMI_22);
    EMI.appendChild(EMI_23);
    EMI.appendChild(EMI_24);
    EMI.appendChild(EMI_25);
    EMI.appendChild(TAC);
    EMI.appendChild(DFE);
    EMI.appendChild(ICC);
    EMI.appendChild(CDE);
    EMI.appendChild(GTE);
    return EMI;
}

const CalcularDigitoVerificacion = (nit) => {
    var contador = 0;
    var vector = new Array(3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71);
    var acumulador = 0;
    var residuo = 0;
    for (contador = 0; contador < nit.length; contador++) {
        var temp = nit[(nit.length - 1) - contador];
        acumulador = acumulador + (temp * vector[contador]);
    }

    residuo = acumulador % 11;
    return residuo > 1 ? 11 - residuo : residuo;
}

const ADQ = (doc, iva, addressedTo, data) => {
    var ADQ = doc.createElement("ADQ");
    if (addressedTo === "Paciente") {
        var code = null;
        switch (data.paciente.tip_documento) {
            case 'CC':
                code = 13;
                break;
            case 'CE':
                code = 22;
                break;
            case 'TE':
                code = 21;
                break;
            case 'TI':
                code = 12;
                break;
            case 'NIT':
                code = 31;
                break;
            case 'RC':
                code = 11;
                break;
            case 'PA':
                code = 41;
                break;
        }

        var ADQ_1 = doc.createElement("ADQ_1");
        ADQ_1.innerHTML = 2;

        var ADQ_2 = doc.createElement("ADQ_2");
        ADQ_2.innerHTML = data.paciente.num_documento; //paciente documento

        var ADQ_3 = doc.createElement("ADQ_3");
        ADQ_3.innerHTML = code; //codigo tipo de documento

        var ADQ_4 = doc.createElement("ADQ_4");
        ADQ_4.innerHTML = 49; //codigo grava con IVA

        var ADQ_6 = doc.createElement("ADQ_6");
        ADQ_6.innerHTML = `${data.paciente.nombres} ${data.paciente.apellido1} ${data.paciente.apellido2}`; //Nombre de la persona natural o RUT

        var ADQ_7 = doc.createElement("ADQ_7");
        ADQ_7.innerHTML = `${data.paciente.nombres} ${data.paciente.apellido1} ${data.paciente.apellido2}`; //Nombre de la persona natural o RUT

        var ADQ_8 = doc.createElement("ADQ_8");
        ADQ_8.innerHTML = `${data.paciente.nombres} ${data.paciente.apellido1} ${data.paciente.apellido2}`; // nombre completo del paciente

        var ADQ_9 = doc.createElement("ADQ_9");
        ADQ_9.innerHTML = "final";

        var ADQ_10 = doc.createElement("ADQ_10");
        ADQ_10.innerHTML = data.paciente.direccion.direccion; // dirección del paciente

        //CAMBIO_FACTURA: Cambiar por el DPTO de la Clinica
        var ADQ_11 = doc.createElement("ADQ_11");
        ADQ_11.innerHTML = data.paciente.direccion.id_departamento; // codigo del departamento

        var ADQ_13 = doc.createElement("ADQ_13");
        ADQ_13.innerHTML = "CALI";//data.paciente.direccion.ciudad; //nombre de la Ciudad en Mayuscula sostenida

        var ADQ_14 = doc.createElement("ADQ_14");
        ADQ_14.innerHTML = "760011"; //codigo postal

        var ADQ_15 = doc.createElement("ADQ_15");
        ADQ_15.innerHTML = "CO"; //codigo del país

        var ADQ_19 = doc.createElement("ADQ_19");
        ADQ_19.innerHTML = "VALLE DEL CAUCA";//data.paciente.direccion.departamento; //nombre del departamento en Mayuscula sostenida

        var ADQ_21 = doc.createElement("ADQ_21");
        ADQ_21.innerHTML = "Colombia"; //nombre del país

        var ADQ_22 = doc.createElement("ADQ_22");
        ADQ_22.innerHTML = CalcularDigitoVerificacion(data.clinica.nit.split("-")[0]); //CV del nit

        //CAMBIO_FACTURA: Cambiar por la CIUDAD de la Clinica
        var ADQ_23 = doc.createElement("ADQ_23");
        ADQ_23.innerHTML = data.paciente.direccion.id_ciudad; // codigo del municipio

        var ADQ_24 = doc.createElement("ADQ_24");
        ADQ_24.innerHTML = data.paciente.num_documento; // número que identifica al consumidor

        var TCR = doc.createElement("TCR");

        var TCR_1 = doc.createElement("TCR_1");
        TCR_1.innerHTML = 'R-99-PN';
        TCR.appendChild(TCR_1);

        var ILA = doc.createElement("ILA");

        var ILA_1 = doc.createElement("ILA_1");
        ILA_1.innerHTML = `${data.paciente.nombres} ${data.paciente.apellido1} ${data.paciente.apellido2}`; //nombre cliente natural o juridico

        var ILA_2 = doc.createElement("ILA_2");
        ILA_2.innerHTML = data.paciente.num_documento; // numero del documento paciente

        var ILA_3 = doc.createElement("ILA_3");
        ILA_3.innerHTML = code; //tipo de documento NIT (persona Juridica) o CC/TI/CE (en caso de ser persona natural)
        var ILA_4 = doc.createElement("ILA_4");
        ILA_4.innerHTML = CalcularDigitoVerificacion(data.clinica.nit.split("-")[0]);

        ILA.appendChild(ILA_1);
        ILA.appendChild(ILA_2);
        ILA.appendChild(ILA_3);
        ILA.appendChild(ILA_4);

        var DFA = doc.createElement("DFA");

        var DFA_1 = doc.createElement("DFA_1");
        DFA_1.innerHTML = "CO"; //codigo del país 34

        //CAMBIO_FACTURA: Cambiar por el DPTO de la Clinica
        var DFA_2 = doc.createElement("DFA_2");
        DFA_2.innerHTML = data.paciente.direccion.id_departamento; //codigo del departamento

        var DFA_3 = doc.createElement("DFA_3");
        DFA_3.innerHTML = "760036"; //codigo postal

        //CAMBIO_FACTURA: Cambiar por la ciudad de la CLINICA
        var DFA_4 = doc.createElement("DFA_4");
        DFA_4.innerHTML = data.paciente.direccion.id_ciudad; //codigo del ciudad

        var DFA_5 = doc.createElement("DFA_5");
        DFA_5.innerHTML = "Colombia"; //nombre del país

        var DFA_6 = doc.createElement("DFA_6");
        DFA_6.innerHTML = data.paciente.direccion.departamento; //nombre del departamento

        var DFA_7 = doc.createElement("DFA_7");
        DFA_7.innerHTML = data.paciente.direccion.ciudad; //ciudad nombre

        var DFA_8 = doc.createElement("DFA_8");
        DFA_8.innerHTML = data.paciente.direccion.direccion; //dirección de la empresa

        var ICR = doc.createElement("ICR");

        DFA.appendChild(DFA_1);
        DFA.appendChild(DFA_2);
        DFA.appendChild(DFA_3);
        DFA.appendChild(DFA_4);
        DFA.appendChild(DFA_5);
        DFA.appendChild(DFA_6);
        DFA.appendChild(DFA_7);
        DFA.appendChild(DFA_8);

        ADQ.appendChild(ADQ_1);
        ADQ.appendChild(ADQ_2);
        ADQ.appendChild(ADQ_3);
        ADQ.appendChild(ADQ_4);
        ADQ.appendChild(ADQ_6);
        ADQ.appendChild(ADQ_7);
        ADQ.appendChild(ADQ_8);
        ADQ.appendChild(ADQ_9);
        ADQ.appendChild(ADQ_10);
        ADQ.appendChild(ADQ_11);
        ADQ.appendChild(ADQ_13);
        ADQ.appendChild(ADQ_14);
        ADQ.appendChild(ADQ_15);
        ADQ.appendChild(ADQ_19);
        ADQ.appendChild(ADQ_21);
        ADQ.appendChild(ADQ_22);
        ADQ.appendChild(ADQ_23);
        ADQ.appendChild(ADQ_24);
        ADQ.appendChild(TCR);
        ADQ.appendChild(ILA);
        ADQ.appendChild(DFA);
        ADQ.appendChild(ICR);

    } else if (addressedTo === "Tercero") {
        var ADQ_1 = doc.createElement("ADQ_1");
        ADQ_1.innerHTML = 1;

        var ADQ_2 = doc.createElement("ADQ_2");
        ADQ_2.innerHTML = data.tercero.nit.split("-")[0]; //NIT del tercero

        var ADQ_3 = doc.createElement("ADQ_3");
        ADQ_3.innerHTML = 31; //codigo del NIT

        var ADQ_4 = doc.createElement("ADQ_4");
        ADQ_4.innerHTML = 49; //codigo grava con IVA

        var ADQ_6 = doc.createElement("ADQ_6");
        ADQ_6.innerHTML = data.tercero.nombre; //Nombre de la empresa

        var ADQ_7 = doc.createElement("ADQ_7");
        ADQ_7.innerHTML = data.tercero.nombre; //Nombre de la empresa

        var ADQ_10 = doc.createElement("ADQ_10");
        ADQ_10.innerHTML = data.tercero.direccion; // dirección de la empresa

        var ADQ_11 = doc.createElement("ADQ_11");
        ADQ_11.innerHTML = "76"; //data.tercero.direccion.id_departamento; // codigo del departamento de la empresa

        var ADQ_13 = doc.createElement("ADQ_13");
        ADQ_13.innerHTML = data.tercero.ciudad; //nombre de la Ciudad en Mayuscula sostenida

        var ADQ_14 = doc.createElement("ADQ_14");
        ADQ_14.innerHTML = "760036"; //codigo postal

        var ADQ_15 = doc.createElement("ADQ_15");
        ADQ_15.innerHTML = "CO"; //codigo del país

        var ADQ_19 = doc.createElement("ADQ_19");
        ADQ_19.innerHTML = data.tercero.departamento;  //nombre del departamento en Mayuscula sostenida

        var ADQ_21 = doc.createElement("ADQ_21");
        ADQ_21.innerHTML = "Colombia"; //nombre del país

        var ADQ_22 = doc.createElement("ADQ_22");
        ADQ_22.innerHTML = CalcularDigitoVerificacion("123456789"); //CV del nit

        var ADQ_23 = doc.createElement("ADQ_23");
        ADQ_23.innerHTML = "76001";//data.tercero.direccion.id_ciudad; // codigo del municipio

        var ADQ_24 = doc.createElement("ADQ_24");
        ADQ_24.innerHTML = data.tercero.nit.split("-")[0]; //número que identifica al consumidor

        var TCR = doc.createElement("TCR");
        var TCR_1 = doc.createElement("TCR_1");
        TCR_1.innerHTML = 'R-99-PN';
        TCR.appendChild(TCR_1);

        var ILA = doc.createElement("ILA");

        var ILA_1 = doc.createElement("ILA_1");
        ILA_1.innerHTML = data.tercero.nombre; //nombre cliente natural o juridico

        var ILA_2 = doc.createElement("ILA_2");
        ILA_2.innerHTML = data.tercero.nit.split("-")[0]; // numero del documento paciente

        var ILA_3 = doc.createElement("ILA_3");
        ILA_3.innerHTML = 31; //tipo de documento NIT (persona Juridica) o CC/TI/CE (en caso de ser persona natural)

        var ILA_4 = doc.createElement("ILA_4");
        ILA_4.innerHTML = CalcularDigitoVerificacion(data.tercero.nit.split("-")[0]); //
        ILA.appendChild(ILA_1);
        ILA.appendChild(ILA_2);
        ILA.appendChild(ILA_3);
        ILA.appendChild(ILA_4);

        var DFA = doc.createElement("DFA");
        var DFA_1 = doc.createElement("DFA_1");
        DFA_1.innerHTML = "CO"; //codigo del país

        var DFA_2 = doc.createElement("DFA_2");
        DFA_2.innerHTML = "76";//data.tercero.direccion.id_departamento; //codigo del departamento

        var DFA_3 = doc.createElement("DFA_3");
        DFA_3.innerHTML = "760036"; //codigo postal

        var DFA_4 = doc.createElement("DFA_4");
        DFA_4.innerHTML = "76001";//data.tercero.direccion.id_ciudad; //codigo del ciudad

        var DFA_5 = doc.createElement("DFA_5");
        DFA_5.innerHTML = "Colombia"; //nombre del país

        var DFA_6 = doc.createElement("DFA_6");
        DFA_6.innerHTML = data.tercero.direccion.departamento; //codigo del departamento

        var DFA_7 = doc.createElement("DFA_7");
        DFA_7.innerHTML = data.tercero.direccion.ciudad;  //ciudad nombre

        var DFA_8 = doc.createElement("DFA_8");
        DFA_8.innerHTML = data.tercero.direccion; //dirección de la empresa

        DFA.appendChild(DFA_1);
        DFA.appendChild(DFA_2);
        DFA.appendChild(DFA_3);
        DFA.appendChild(DFA_4);
        DFA.appendChild(DFA_5);
        DFA.appendChild(DFA_6);
        DFA.appendChild(DFA_7);
        DFA.appendChild(DFA_8);

        var ICR = doc.createElement("ICR");
        var ICR_1 = doc.createElement("ICR_1");
        ICR_1.innerHTML = data.tercero.nit.split("-")[0]; // número de matrícula mercantil campo obligatorio persona juridica;       
        ICR.appendChild(ICR_1);

        ADQ.appendChild(ADQ_1);
        ADQ.appendChild(ADQ_2);
        ADQ.appendChild(ADQ_3);
        ADQ.appendChild(ADQ_4);
        ADQ.appendChild(ADQ_6);
        ADQ.appendChild(ADQ_7);
        ADQ.appendChild(ADQ_10);
        ADQ.appendChild(ADQ_11);
        ADQ.appendChild(ADQ_13);
        ADQ.appendChild(ADQ_14);
        ADQ.appendChild(ADQ_15);
        ADQ.appendChild(ADQ_19);
        ADQ.appendChild(ADQ_21);
        ADQ.appendChild(ADQ_22);
        ADQ.appendChild(ADQ_23);
        ADQ.appendChild(ADQ_24);
        ADQ.appendChild(TCR);
        ADQ.appendChild(ILA);
        ADQ.appendChild(DFA);
        ADQ.appendChild(ICR);
    }

    var GTA = doc.createElement("GTA");
    var GTA_1 = doc.createElement("GTA_1");
    var GTA_2 = doc.createElement("GTA_2");

    if (iva) {
        GTA_1.innerHTML = "01";
        GTA_2.innerHTML = "IVA";
    } else {
        GTA_1.innerHTML = "ZZ";
        GTA_2.innerHTML = "No aplica";
    }
    GTA.appendChild(GTA_1);
    GTA.appendChild(GTA_2);

    var CDA = doc.createElement("CDA");
    var CDA_1 = doc.createElement("CDA_1");
    CDA_1.innerHTML = 1;
    CDA.appendChild(CDA_1);

    if (addressedTo === "Paciente") {
        var CDA_2 = doc.createElement("CDA_2");
        CDA_2.innerHTML = `${data.paciente.nombres} ${data.paciente.apellido1} ${data.paciente.apellido2}`; //nombre del paciente
        var CDA_3 = doc.createElement("CDA_3");
        CDA_3.innerHTML = data.paciente.telefono1; //telefono del paciente
        var CDA_4 = doc.createElement("CDA_4");
        CDA_4.innerHTML = data.paciente.correo; //correo del paciente (campo obligatorio)
        CDA.appendChild(CDA_2);
        CDA.appendChild(CDA_3);
        CDA.appendChild(CDA_4);

    } else if (addressedTo === "Tercero") {
        var CDA_2 = doc.createElement("CDA_2");
        CDA_2.innerHTML = data.tercero.nombre; //nombre del cliente
        var CDA_3 = doc.createElement("CDA_3");
        CDA_3.innerHTML = data.tercero.telefono1; //telefono del cliente
        var CDA_4 = doc.createElement("CDA_4");
        CDA_4.innerHTML = data.tercero.correo; //correo del cliente (campo obligatorio)

        CDA.appendChild(CDA_2);
        CDA.appendChild(CDA_3);
        CDA.appendChild(CDA_4);

    }

    ADQ.appendChild(CDA);
    ADQ.appendChild(GTA);

    return ADQ;
}

const TOT = (doc, type, iva, data) => {
    var TOT = doc.createElement("TOT");
    //var valorAnticipo = 0;
    var TOT_1 = doc.createElement("TOT_1");
    var TOT_2 = doc.createElement("TOT_2");
    var TOT_3 = doc.createElement("TOT_3");
    var TOT_4 = doc.createElement("TOT_4");
    var TOT_5 = doc.createElement("TOT_5");
    var TOT_6 = doc.createElement("TOT_6");
    var TOT_7 = doc.createElement("TOT_7");
    var TOT_8 = doc.createElement("TOT_8");
    var TOT_9 = doc.createElement("TOT_9");
    var TOT_10 = doc.createElement("TOT_10");
    var TOT_11 = doc.createElement("TOT_11");
    var TOT_12 = doc.createElement("TOT_12");
    var TOT_13 = doc.createElement("TOT_13");
    var TOT_14 = doc.createElement("TOT_14");

    if (type === "FACTURA") {
        if (iva) {
            if (data.origen === "Paciente") {
                TOT_1.innerHTML = data.reciboCaja.total; //total factura
                TOT_2.innerHTML = "COP";
                TOT_3.innerHTML = data.reciboCaja.total; //total factura 
                TOT_4.innerHTML = "COP";
                TOT_5.innerHTML = data.reciboCaja.total; //total factura mas IVA menos descuentos
                TOT_6.innerHTML = "COP";
                TOT_7.innerHTML = data.reciboCaja.total; //total factura mas IVA
                TOT_8.innerHTML = "COP";
            } else if (data.origen === "Tercero") {
                var totalTercero = 0;
                data.factTercero.servicios.facturas.map((factura) => {
                    totalTercero += factura.valor_tercero;
                });
                TOT_1.innerHTML = totalTercero; //total factura
                TOT_2.innerHTML = "COP";
                TOT_3.innerHTML = totalTercero; //total factura 
                TOT_4.innerHTML = "COP";
                TOT_5.innerHTML = totalTercero * 1.19; //total factura mas IVA menos descuentos
                TOT_6.innerHTML = "COP";
                TOT_7.innerHTML = totalTercero * 1.19; //total factura mas IVA
                TOT_8.innerHTML = "COP";
            }

        } else {
            if (data.origen === "Paciente") {
                TOT_1.innerHTML = data.reciboCaja.total; //total factura
                TOT_2.innerHTML = "COP";
                TOT_3.innerHTML = 0; //total factura 
                TOT_4.innerHTML = "COP";
                TOT_5.innerHTML = data.reciboCaja.total; //total factura mas IVA menos descuentos
                TOT_6.innerHTML = "COP";
                TOT_7.innerHTML = data.reciboCaja.total; //total factura mas IVA
                TOT_8.innerHTML = "COP";

            } else if (data.origen === "Tercero") {
                var totalTercero = 0;
                data.factTercero.servicios.recibos_caja.map((factura) => {
                    totalTercero += factura.valor_tercero;
                });
                var totalDescuentos = 0;
                data.factTercero.servicios.recibos_caja.map((factura) => {
                    totalDescuentos += factura.total;
                });
                TOT_1.innerHTML = totalTercero; //total factura
                TOT_2.innerHTML = "COP";
                TOT_3.innerHTML = totalTercero; //total factura 
                TOT_4.innerHTML = "COP";
                TOT_5.innerHTML = totalTercero; //total factura mas IVA menos descuentos
                TOT_6.innerHTML = "COP";
                TOT_7.innerHTML = totalTercero; //total factura mas IVA
                TOT_8.innerHTML = "COP";
                TOT_9.innerHTML = totalDescuentos; //descuentos               
                TOT_10.innerHTML = "COP";
                TOT_11.innerHTML = totalDescuentos; //total cargos
                TOT_12.innerHTML = "COP";
                TOT_13.innerHTML = totalDescuentos; //total anticipos
                TOT_14.innerHTML = "COP";

            }
        }

    } else if (type === 'ND' || type === 'NC') {
        if (iva) {
            if (data.hasOwnProperty("notac")) {
                TOT_1.innerHTML = data.notac.monto; //total factura
                TOT_2.innerHTML = "COP";
                TOT_3.innerHTML = data.notac.monto; //total factura 
                TOT_4.innerHTML = "COP";
                TOT_5.innerHTML = data.notac.monto * 1.19; //total factura mas IVA menos descuentos
                TOT_6.innerHTML = "COP";
                TOT_7.innerHTML = data.notac.monto * 1.19; //total factura mas IVA
                TOT_8.innerHTML = "COP";
                TOT_9.innerHTML = 0; //descuentos
                TOT_10.innerHTML = "COP";
            } else if (data.hasOwnProperty("notad")) {
                TOT_1.innerHTML = data.notad.monto; //total factura
                TOT_2.innerHTML = "COP";
                TOT_3.innerHTML = data.notad.monto; //total factura 
                TOT_4.innerHTML = "COP";
                TOT_5.innerHTML = data.notad.monto * 1.19; //total factura mas IVA menos descuentos
                TOT_6.innerHTML = "COP";
                TOT_7.innerHTML = data.notad.monto * 1.19; //total factura mas IVA
                TOT_8.innerHTML = "COP";
                TOT_9.innerHTML = 0; //descuentos
                TOT_10.innerHTML = "COP";
            }

        } else {
            if (data.hasOwnProperty("notac")) {
                TOT_1.innerHTML = data.notac.monto; //total factura
                TOT_2.innerHTML = "COP";
                TOT_3.innerHTML = 0; //total factura 
                TOT_4.innerHTML = "COP";
                TOT_5.innerHTML = data.notac.monto; //total factura mas IVA menos descuentos
                TOT_6.innerHTML = "COP";
                TOT_7.innerHTML = data.notac.monto; //total factura mas IVA
                TOT_8.innerHTML = "COP";
                TOT_9.innerHTML = 0; //descuentos
                TOT_10.innerHTML = "COP";
            } else if (data.hasOwnProperty("notad")) {
                TOT_1.innerHTML = data.notad.monto; //total factura
                TOT_2.innerHTML = "COP";
                TOT_3.innerHTML = 0; //total factura 
                TOT_4.innerHTML = "COP";
                TOT_5.innerHTML = data.notad.monto; //total factura mas IVA menos descuentos
                TOT_6.innerHTML = "COP";
                TOT_7.innerHTML = data.notad.monto; //total factura mas IVA
                TOT_8.innerHTML = "COP";
                TOT_9.innerHTML = 0; //descuentos
                TOT_10.innerHTML = "COP";
            }
        }
    }

    TOT.appendChild(TOT_1);
    TOT.appendChild(TOT_2);
    TOT.appendChild(TOT_3);
    TOT.appendChild(TOT_4);
    TOT.appendChild(TOT_5);
    TOT.appendChild(TOT_6);
    TOT.appendChild(TOT_7);
    TOT.appendChild(TOT_8);

    if (TOT_9.innerHTML !== "")
        TOT.appendChild(TOT_9);

    if (TOT_10.innerHTML !== "")
        TOT.appendChild(TOT_10);

    if (TOT_11.innerHTML !== "")
        TOT.appendChild(TOT_11);

    if (TOT_12.innerHTML !== "")
        TOT.appendChild(TOT_12);

    if (TOT_13.innerHTML !== "")
        TOT.appendChild(TOT_13);

    if (TOT_14.innerHTML !== "")
        TOT.appendChild(TOT_14);

    return TOT;
}

const TIM = (doc, iva, data) => {
    if (iva) {
        if (data.origen === 'Paciente') {
            var TIM = doc.createElement("TIM");
            var TIM_1 = doc.createElement("TIM_1");// indica si el elemento es retenido o de retencion
            TIM_1.innerHTML = "true";
            var TIM_2 = doc.createElement("TIM_2");
            TIM_2.innerHTML = data.reciboCaja.total * 0.19; //valor IVA
            var TIM_3 = doc.createElement("TIM_3");//moneda de impouesto
            TIM_3.innerHTML = "COP";
            var IMP = doc.createElement("IMP");
            var IMP_1 = doc.createElement("IMP_1"); //tipo clase de impuesto
            IMP_1.innerHTML = "01";
            var IMP_2 = doc.createElement("IMP_2");
            IMP_2.innerHTML = data.reciboCaja.total; //total sin iva
            var IMP_3 = doc.createElement("IMP_3");
            IMP_3.innerHTML = "COP";
            var IMP_4 = doc.createElement("IMP_4");
            IMP_4.innerHTML = data.reciboCaja.total * 0.19; //IVA
            var IMP_5 = doc.createElement("IMP_5");
            IMP_5.innerHTML = "COP";
            var IMP_6 = doc.createElement("IMP_6");
            IMP_6.innerHTML = 19.00;
            TIM.appendChild(TIM_1);
            TIM.appendChild(TIM_2);
            TIM.appendChild(TIM_3);
            IMP.appendChild(IMP_1);
            IMP.appendChild(IMP_2);
            IMP.appendChild(IMP_3);
            IMP.appendChild(IMP_4);
            IMP.appendChild(IMP_5);
            IMP.appendChild(IMP_6);
            TIM.appendChild(IMP);
        } else if (data.origen === 'Tercero') {

            var totalTercero = 0;
            data.factTercero.servicios.facturas.map((factura) => {
                totalTercero += factura.valor_tercero;
            });
            var TIM = doc.createElement("TIM");
            var TIM_1 = doc.createElement("TIM_1");
            TIM_1.innerHTML = "true"; //total factura
            var TIM_2 = doc.createElement("TIM_2");
            TIM_2.innerHTML = totalTercero * 1.19; //valor IVA
            var TIM_3 = doc.createElement("TIM_3");
            TIM_3.innerHTML = "COP"; //total factura 
            var IMP = doc.createElement("IMP");
            var IMP_1 = doc.createElement("IMP_1");
            IMP_1.innerHTML = "01";
            var IMP_2 = doc.createElement("IMP_2");
            IMP_2.innerHTML = totalTercero; //total sin iva
            var IMP_3 = doc.createElement("IMP_3");
            IMP_3.innerHTML = "COP";
            var IMP_4 = doc.createElement("IMP_4");
            IMP_4.innerHTML = totalTercero * 0.19; //IVA
            var IMP_5 = doc.createElement("IMP_5");
            IMP_5.innerHTML = "COP";
            var IMP_6 = doc.createElement("IMP_6");
            IMP_6.innerHTML = 19.00;
            TIM.appendChild(TIM_1);
            TIM.appendChild(TIM_2);
            TIM.appendChild(TIM_3);
            IMP.appendChild(IMP_1);
            IMP.appendChild(IMP_2);
            IMP.appendChild(IMP_3);
            IMP.appendChild(IMP_4);
            IMP.appendChild(IMP_5);
            IMP.appendChild(IMP_6);
            TIM.appendChild(IMP);
        }
        return TIM;
    }
}

const ANT = (doc, addressedTo, data) => {

    var totalDescuentos = 0;
    data.factTercero.servicios.recibos_caja.map((factura) => {
        totalDescuentos += factura.total;
    });

    if (addressedTo === "Tercero" && (data.reciboCaja.tipo_pago === "CUOTA MODERADORA" || data.reciboCaja.tipo_pago === "COPAGO")) {
        var ANT = doc.createElement("ANT");
        var ANT_1 = doc.createElement("ANT_1");
        ANT_1.innerHTML = totalDescuentos; //valor copago/cuota moderadora (motivo)
        var ANT_2 = doc.createElement("ANT_2");
        ANT_2.innerHTML = "COP"; //valor IVA
        var ANT_3 = doc.createElement("ANT_3");
        ANT_3.innerHTML = moment(data.fecha_inicio).format("YYYY-MM-DD"); //fecha de pago anticipo
        var ANT_4 = doc.createElement("ANT_4");
        ANT_4.innerHTML = moment(data.fecha_inicio).format("HH:MM A"); //hora
        var ANT_5 = doc.createElement("ANT_5");
        ANT_5.innerHTML = data.factTercero.tipo; //Motivo
        var ANT_6 = doc.createElement("ANT_6");
        ANT_6.innerHTML = moment(data.fecha_final).format("YYYY-MM-DD"); //fecha de la recepcion del anticipo
        ANT.appendChild(ANT_1);
        ANT.appendChild(ANT_2);
        ANT.appendChild(ANT_3);
        ANT.appendChild(ANT_4);
        ANT.appendChild(ANT_5);
        ANT.appendChild(ANT_6);
    }

    return ANT
}

const DRF = (doc, data, addressedTo) => {
    var DRF = doc.createElement("DRF");
    var DRF_1 = doc.createElement("DRF_1");
    DRF_1.innerHTML = "18764000864293";//codigo de autorización
    var DRF_2 = doc.createElement("DRF_2");
    DRF_2.innerHTML = "2020-07-14"; //fecha de inicio facturas
    var DRF_3 = doc.createElement("DRF_3");
    DRF_3.innerHTML = "2022-01-14"; //fecha de terminación facturas
    var DRF_4 = doc.createElement("DRF_4");

    if(addressedTo === "Paciente")
    DRF_4.innerHTML = data.factura.prefijo; //prefijo
    else
    DRF_4.innerHTML = data.prefijo; //prefijo

    var DRF_5 = doc.createElement("DRF_5");
    DRF_5.innerHTML = 1; //rango de numeracion minimo 1 maximo 9
    var DRF_6 = doc.createElement("DRF_6");
    DRF_6.innerHTML = 3500; //rango terminacion facturas---------------------------
    DRF.appendChild(DRF_1);
    DRF.appendChild(DRF_2);
    DRF.appendChild(DRF_3);
    DRF.appendChild(DRF_4);
    DRF.appendChild(DRF_5);
    DRF.appendChild(DRF_6);
    return DRF
}

const NOT = (doc, data) => {

    let NOT = doc.createElement("NOT");

    let NOT_1 = doc.createElement("NOT_1");
    NOT_1.innerHTML = data.nota;

    NOT.appendChild(NOT_1);

    return NOT;
}

const REF = (doc, type, data) => {
    var REF = doc.createElement("REF");
    var REF_1 = doc.createElement("REF_1");
    REF_1.innerHTML = type;
    var REF_2 = doc.createElement("REF_2");
    REF_2.innerHTML = "COP"; //prefijo y numero de factura
    var REF_3 = doc.createElement("REF_3");
    REF_3.innerHTML = moment(new Date()).format('YYYY-MM-DD'); //fecha 
    //var REF_4 = doc.createElement("REF_4");
    //REF_4.innerHTML = ""; //codigo CUFE 
    //var REF_5 = doc.createElement("REF_5");
    //REF_5.innerHTML = 'CUFE-SHA384'; //algoritmo con el cual se genero el codigo
    REF.appendChild(REF_1);
    REF.appendChild(REF_2);
    REF.appendChild(REF_3);
    //REF.appendChild(REF_4);
    //REF.appendChild(REF_5);
    return REF
}

const CND = (doc, description) => {
    var CND = doc.createElement("CND");
    var CND_1 = doc.createElement("CND_1");
    CND_1.innerHTML = 2;
    var CND_2 = doc.createElement("CND_2");
    CND_2.innerHTML = description; //descripción
    CND.appendChild(CND_1);
    CND.appendChild(CND_2);
    return CND
}

const MEP = (doc, type, addressedTo, data) => {
    var MEP = doc.createElement("MEP");
    if (type === "FACTURA") {
        var paymentMethod = null;
        var typeArray = new Array();
        var code = null;
        if (addressedTo === 'Paciente') {
            if (data.reciboCaja.medio_pago.medio.map((medio) => medio.medio.includes("Efectivo")).includes(true)) {
                typeArray.push(0);
                paymentMethod = 10;
            }
            if (data.reciboCaja.medio_pago.medio.map((medio) => medio.medio.includes("Debito") || medio.medio.includes("Credito")).includes(true)) {
                typeArray.push(1);
                paymentMethod = 1;
            }
            if (data.reciboCaja.medio_pago.medio.map((medio) => medio.medio.includes("Cheque")).includes(true)) {
                typeArray.push(2);
                paymentMethod = 20;
            }
        } else if (addressedTo === 'CLIENTE') {
            /*if(data.factTercero.medio_pago.medio.map((medio)=>medio.medio.includes("Efectivo")).includes(true)){
                typeArray.push(0);
                paymentMethod = 0; 
            }
            if(data.factTercero.medio_pago.medio.map((medio)=>medio.medio.includes("Debito") || medio.medio.includes("Credito")).includes(true)){
                typeArray.push(1);
                paymentMethod = 1;  
            }
            if(data.factTercero.medio_pago.medio.map((medio)=>medio.medio.includes("Cheque")).includes(true)){
                typeArray.push(2);
                paymentMethod = 2;  
            }*/
        }

        if (typeArray.length > 1) {
            code = "ZZZ";
            paymentMethod = 1;
        } else {
            switch (typeArray[0]) {
                case 0:
                    code = 10;
                case 1:
                    code = 49;
                case 2:
                    code = 20;
                default:
                    code = 10;
            }
        }


        if (addressedTo === "PACIENTE") {
            var MEP_1 = doc.createElement("MEP_1");
            MEP_1.innerHTML = code;
            var MEP_2 = doc.createElement("MEP_2");
            MEP_2.innerHTML = paymentMethod;
            MEP.appendChild(MEP_1);
            MEP.appendChild(MEP_2);
        } else {
            var MEP_1 = doc.createElement("MEP_1");
            MEP_1.innerHTML = 47;
            var MEP_2 = doc.createElement("MEP_2");
            MEP_2.innerHTML = 2;
            var MEP_3 = doc.createElement("MEP_3");
            MEP_3.innerHTML = moment(new Date()).format("YYYY-MM-DD"); //fecha vencimiento factura
            MEP.appendChild(MEP_1);
            MEP.appendChild(MEP_2);
            MEP.appendChild(MEP_3);
        }

    }

    return MEP;
}


const ITEM = (doc, facturaXML, type, iva, addressedTo, data, descuento) => {
    var items = [];
    if (addressedTo === "Paciente") {
        items = [data.reciboCaja];
    } else if (addressedTo === "Tercero") {
        items = data.factTercero.servicios.recibos_caja;
    }
    var countGroup = 1;
    var itemsBill = null;
    switch (type) {
        case 'FACTURA':
            items.forEach((item, index) => {
                var ITE = doc.createElement("ITE");
                var ITE_1 = doc.createElement("ITE_1");
                ITE_1.innerHTML = 1;

                var ITE_3 = doc.createElement("ITE_3");
                ITE_3.innerHTML = 1; //cantidad
                var ITE_4 = doc.createElement("ITE_4");
                ITE_4.innerHTML = "94"; //unidad de medida
                var ITE_5 = doc.createElement("ITE_5");
                ITE_5.innerHTML = item.total; //total cantidad*valor_unitario
                var ITE_6 = doc.createElement("ITE_6");
                ITE_6.innerHTML = "COP";
                var ITE_7 = doc.createElement("ITE_7");
                ITE_7.innerHTML = item.total; //precio
                var ITE_8 = doc.createElement("ITE_8");
                ITE_8.innerHTML = "COP";
                var ITE_11 = doc.createElement("ITE_11");
                if (addressedTo === "Tercero") 
                ITE_11.innerHTML = "Derechos registrados por IPS: copago (240790-Copago-222333444555) acreditado a subcuenta _EPS_ERP_NIT_ por concepto de 1319 Prestación de servicios de salud";
                else
                ITE_11.innerHTML = item.servicios.servicios[0].servicios; //nombre del item

                var ITE_12 = doc.createElement("ITE_12");
                if (addressedTo === "Tercero") 
                ITE_12.innerHTML = "Ingreso por determinar: copago (241790-Copago-222333444555) debitado en la cuenta 240790 Otros recursos a favor de terceros";
                else
                ITE_12.innerHTML = item.servicios.servicios[0].servicios; //nombre del item                
                var ITE_17 = doc.createElement("ITE_17");
                ITE_17.innerHTML = "01"; //codigo
                var ITE_18 = doc.createElement("ITE_18");
                ITE_18.innerHTML = "1" //codigo de la empresa
                var ITE_19 = doc.createElement("ITE_19");
                ITE_19.innerHTML = item.total; //valor con descuentos
                var ITE_20 = doc.createElement("ITE_20");
                ITE_20.innerHTML = "COP";
                var ITE_21 = doc.createElement("ITE_21");
                ITE_21.innerHTML = item.total; //valor
                var ITE_22 = doc.createElement("ITE_22");
                ITE_22.innerHTML = "COP";
                var ITE_27 = doc.createElement("ITE_27");
                ITE_27.innerHTML = 1;
                var ITE_28 = doc.createElement("ITE_28");
                ITE_28.innerHTML = 94; //codigo empresa 

                ITE.appendChild(ITE_1);
                ITE.appendChild(ITE_3);
                ITE.appendChild(ITE_4);
                ITE.appendChild(ITE_5);
                ITE.appendChild(ITE_6);
                ITE.appendChild(ITE_7);
                ITE.appendChild(ITE_8);
                ITE.appendChild(ITE_11);
                ITE.appendChild(ITE_12);
                ITE.appendChild(ITE_17);
                ITE.appendChild(ITE_18);
                ITE.appendChild(ITE_19);
                ITE.appendChild(ITE_20);
                ITE.appendChild(ITE_21);
                ITE.appendChild(ITE_22);
                ITE.appendChild(ITE_27);
                ITE.appendChild(ITE_28);

                if (item["total"] === 0) {
                    var IPA = doc.createElement("IPA");
                    var IPA_1 = doc.createElement("IPA_1");
                    IPA_1.innerHTML = '01';
                    var IPA_2 = doc.createElement("IPA_2");
                    IPA_2.innerHTML = 1;
                    var IPA_3 = doc.createElement("IPA_3");
                    IPA_3.innerHTML = 'COP';
                    IPA.appendChild(IPA_1);
                    IPA.appendChild(IPA_2);
                    IPA.appendChild(IPA_3);
                    ITE.appendChild(IPA);
                }

                var IAE = doc.createElement("IAE");
                var IAE_1 = doc.createElement("IAE_1");
                IAE_1.innerHTML = '01';
                var IAE_2 = doc.createElement("IAE_2");
                IAE_2.innerHTML = 999;

                IAE.appendChild(IAE_1);
                IAE.appendChild(IAE_2);
                ITE.appendChild(IAE);

                var descuento = 0;

                if (descuento > 0) {
                    var IDE = doc.createElement("IDE");
                    var IDE_1 = doc.createElement("IDE_1");
                    IDE_1.innerHTML = false;
                    var IDE_2 = doc.createElement("IDE_2");
                    IDE_2.innerHTML = ""; //descuento
                    var IDE_3 = doc.createElement("IDE_3");
                    IDE_3.innerHTML = "COP";
                    var IDE_5 = doc.createElement("IDE_5");
                    IDE_5.innerHTML = "DESCUENTO"; //descuento
                    var IDE_6 = doc.createElement("IDE_6");
                    IDE_6.innerHTML = ""; //valor total
                    var IDE_7 = doc.createElement("IDE_7");
                    IDE_7.innerHTML = ""; //descuento
                    var IDE_8 = doc.createElement("IDE_8");
                    IDE_8.innerHTML = "COP";
                    var IDE_10 = doc.createElement("IDE_10");
                    IDE_10.innerHTML = countGroup; //descuento
                    countGroup++

                    IDE.appendChild(IDE_1);
                    IDE.appendChild(IDE_2);
                    IDE.appendChild(IDE_3);
                    IDE.appendChild(IDE_5);
                    IDE.appendChild(IDE_6);
                    IDE.appendChild(IDE_7);
                    IDE.appendChild(IDE_8);
                    IDE.appendChild(IDE_10);
                    ITE.appendChild(IDE);
                }
                if (iva) {
                    var TII = doc.createElement("TII");
                    var TII_1 = doc.createElement("TII_1");
                    TII_1.innerHTML = data.reciboCaja.total * 0.19;
                    var TII_2 = doc.createElement("TII_2");
                    TII_2.innerHTML = "COP";
                    var TII_3 = doc.createElement("TII_3");
                    TII_3.innerHTML = "false";

                    var IIM = doc.createElement("IIM");
                    var IIM_1 = doc.createElement("IIM_1");
                    IIM_1.innerHTML = '01';
                    var IIM_2 = doc.createElement("IIM_2");
                    IIM_2.innerHTML = data.reciboCaja.total * 0.19;
                    var IIM_3 = doc.createElement("IIM_3");
                    IIM_3.innerHTML = 'COP';
                    var IIM_4 = doc.createElement("IIM_4");
                    IIM_4.innerHTML = data.reciboCaja.total;
                    var IIM_5 = doc.createElement("IIM_5");
                    IIM_5.innerHTML = 'COP';
                    var IIM_6 = doc.createElement("IIM_6");
                    IIM_6.innerHTML = 19.0;
                    IIM.appendChild(IIM_1);
                    IIM.appendChild(IIM_2);
                    IIM.appendChild(IIM_3);
                    IIM.appendChild(IIM_4);
                    IIM.appendChild(IIM_5);
                    IIM.appendChild(IIM_6);

                    TII.appendChild(TII_1);
                    TII.appendChild(TII_2);
                    TII.appendChild(TII_3);
                    TII.appendChild(IIM);
                    ITE.appendChild(TII);
                }

                let RFD = doc.createElement("RFD");
                let RFD_1 = doc.createElement("RFD_1");

                if (data.reciboCaja.tipo_pago === "COPAGO")
                    RFD_1.innerHTML = 1;
                else
                    RFD_1.innerHTML = 2;

                RFD.appendChild(RFD_1);
                //ITE.appendChild(RFD);

                let ITS = doc.createElement("ITS");

                let ITS_1 = doc.createElement("ITS_1");
                ITS_1.innerHTML = ""; //UUID identificador del usuario en la sección
                let ITS_2 = doc.createElement("ITS_2");
                ITS_2.innerHTML = ""; //
                let ITS_3 = doc.createElement("ITS_3");
                ITS_3.innerHTML = ""; //Código prestador de servicios de salud Vea la Extensión del SS

                ITS.appendChild(ITS_1);
                ITS.appendChild(ITS_2);
                ITS.appendChild(ITS_3);

                //ITE.appendChild(ITS);

                facturaXML.appendChild(ITE);
            });
            break;
        case 'NC' || 'ND':
            items.forEach((item, index) => {
                var ITE = doc.createElement("ITE");
                var ITE_1 = doc.createElement("ITE_1");
                ITE_1.innerHTML = index;
                var ITE_2 = doc.createElement("ITE_2");
                var ITE_3 = doc.createElement("ITE_3");
                ITE_3.innerHTML = 1; //cantidad
                var ITE_4 = doc.createElement("ITE_4");
                ITE_4.innerHTML = "WSD"; //cantidad
                var ITE_5 = doc.createElement("ITE_5");
                ITE_5.innerHTML = item.valor_tercero; //total (cantidad * valor_unitario)
                var ITE_6 = doc.createElement("ITE_6");
                ITE_6.innerHTML = "COP";
                var ITE_7 = doc.createElement("ITE_7");
                ITE_7.innerHTML = item.valor_tercero; //precio 
                var ITE_8 = doc.createElement("ITE_8");
                ITE_8.innerHTML = "COP";
                var ITE_9 = doc.createElement("ITE_9");
                var ITE_10 = doc.createElement("ITE_10");
                var ITE_11 = doc.createElement("ITE_11");
                ITE_11.innerHTML = ""; //nombre del item
                var ITE_12 = doc.createElement("ITE_12");
                var ITE_13 = doc.createElement("ITE_13");
                var ITE_14 = doc.createElement("ITE_14");
                var ITE_16 = doc.createElement("ITE_16");
                var ITE_17 = doc.createElement("ITE_17");
                ITE_17.innerHTML = "01"; //codigo
                var ITE_19 = doc.createElement("ITE_19");
                ITE_19.innerHTML = 0; //valor con descuentos
                var ITE_20 = doc.createElement("ITE_20");
                ITE_20.innerHTML = "COP";
                var ITE_21 = doc.createElement("ITE_21");
                ITE_21.innerHTML = item.valor_tercero; //valor
                var ITE_22 = doc.createElement("ITE_22");
                ITE_22.innerHTML = "COP";
                var ITE_27 = doc.createElement("ITE_27");
                ITE_27.innerHTML = item.valor_tercero; // cantidad redondeada
                var ITE_28 = doc.createElement("ITE_28");

                var IAE = doc.createElement("IAE");
                var IAE_1 = doc.createElement("IAE_1");
                IAE_1.innerHTML = ""; //codigo UNSPSC del producto
                var IAE_2 = doc.createElement("IAE_2");
                IAE_1.innerHTML = "";

                ITE.appendChild(ITE_1);
                ITE.appendChild(ITE_2);
                ITE.appendChild(ITE_3);
                ITE.appendChild(ITE_4);
                ITE.appendChild(ITE_5);
                ITE.appendChild(ITE_6);
                ITE.appendChild(ITE_7);
                ITE.appendChild(ITE_8);
                ITE.appendChild(ITE_9);
                ITE.appendChild(ITE_10);
                ITE.appendChild(ITE_11);
                ITE.appendChild(ITE_12);
                ITE.appendChild(ITE_13);
                ITE.appendChild(ITE_14);
                ITE.appendChild(ITE_16);
                ITE.appendChild(ITE_17);
                ITE.appendChild(ITE_19);
                ITE.appendChild(ITE_20);
                ITE.appendChild(ITE_21);
                ITE.appendChild(ITE_22);
                ITE.appendChild(ITE_27);
                ITE.appendChild(ITE_28);

                //nuevos camposss
                let RFD = doc.createElement("RFD");
                let RFD_1 = doc.createElement("RFD_1");

                if (data.reciboCaja.tipo_pago === "COPAGO")
                    RFD_1.innerHTML = 1;
                else
                    RFD_1.innerHTML = 2;

                RFD.appendChild(RFD_1);
                ITE.appendChild(RFD);

                let ITS = doc.createElement("ITS");

                let ITS_1 = doc.createElement("ITS_1");
                ITS_1.innerHTML = ""; //UUID identificador del usuario en la sección
                let ITS_2 = doc.createElement("ITS_2");
                ITS_2.innerHTML = ""; //
                let ITS_3 = doc.createElement("ITS_3");
                ITS_3.innerHTML = ""; //Código prestador de servicios de salud Vea la Extensión del SS

                ITS.appendChild(ITS_1);
                ITS.appendChild(ITS_2);
                ITS.appendChild(ITS_3);

                ITE.appendChild(ITS);

                facturaXML.appendChild(ITE);
            })
            break;
    }

    //return ITE;
}

const AditionalFields = (doc, facturaXML, addressedTo, data) => {

    let PAG = doc.createElement("PAG");

    let PAG_1 = doc.createElement("PAG_1");
    PAG_1.innerHTML = "";//Nombre del elemento a informar Nombre deTipo de Archivo o documento

    let PAG_2 = doc.createElement("PAG_2");
    PAG_2.innerHTML = ""; //Valor del elemento a informar (Nombre del documento+Ext del documento)

    PAG.appendChild(PAG_1);
    PAG.appendChild(PAG_2);

    facturaXML.appendChild(PAG);
    if (addressedTo === "Paciente") {

        let USS = doc.createElement("USS");

        let USS_1 = doc.createElement("USS_1");
        USS_1.innerHTML = data.paciente.num_documento;//dentificador del Usuario beneficiario del servicio de salud ID
        let USS_2 = doc.createElement("USS_2");
        USS_2.innerHTML = 91; //schemeID 
        let USS_3 = doc.createElement("USS_3");
        USS_3.innerHTML = data.paciente.nombres;//Nombres del Usuario beneficiario del servicio de salud FirstName
        let USS_4 = doc.createElement("USS_4");
        USS_4.innerHTML = + data.paciente.apellido1 + " " + data.paciente.apellido2;//Apellidos del Usuario beneficiario del servicio de salud FamilyName   

        USS.appendChild(USS_1);
        USS.appendChild(USS_2);
        USS.appendChild(USS_3);
        USS.appendChild(USS_4);

        facturaXML.appendChild(USS);
    }
}


export default BuildXml;